module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_bg_down1_2024_2025_en.1788405320306.png";